import {
  NewSurveyQuestion,
  SurveyQuestion,
} from "data/slices/surveyquestions/interface";

/**
 * Maps the new API response format to the format expected by the UI
 */
export const surveyQuestionsMapper = (
  questions: NewSurveyQuestion[],
): SurveyQuestion[] => {
  if (!questions || !Array.isArray(questions)) {
    return [];
  }

  return questions.map((question) => ({
    id: question.Id,
    questionText: question.QuestionText,
    questionType:
      question.type.charAt(0).toUpperCase() + question.type.slice(1), // Capitalize first letter
    options:
      question.Answers?.map((option) => ({
        id: option.id,
        optionText: option.text,
        value: option.text, // Using text as value since value is not provided in the new format
      })) || [],
  }));
};
